/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_FormulaInputs */

const tr_katalog_desi_formula = /** @type {(inputs: Katalog_Desi_FormulaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(En × Boy × Yükseklik) / 3000`)
};

const en_katalog_desi_formula = /** @type {(inputs: Katalog_Desi_FormulaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Width × Length × Height) / 3000`)
};

const de_katalog_desi_formula = /** @type {(inputs: Katalog_Desi_FormulaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Breite × Länge × Höhe) / 3000`)
};

const ru_katalog_desi_formula = /** @type {(inputs: Katalog_Desi_FormulaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Ширина × Длина × Высота) / 3000`)
};

/**
* | output |
* | --- |
* | "(Width × Length × Height) / 3000" |
*
* @param {Katalog_Desi_FormulaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_formula = /** @type {((inputs?: Katalog_Desi_FormulaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_FormulaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_formula(inputs)
	if (locale === "de") return de_katalog_desi_formula(inputs)
	if (locale === "ru") return ru_katalog_desi_formula(inputs)
	return tr_katalog_desi_formula(inputs)
});